export default "__VITE_ASSET__ChcjtbkW__"